import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimaryBtnComponent } from '../../buttons/primary-btn/primary-btn.component';
import { SecondaryBtnComponent } from '../../buttons/secondary-btn/secondary-btn.component';

@Component({
  selector: 'app-pop-tray',
  standalone: true,
  imports: [CommonModule, PrimaryBtnComponent, SecondaryBtnComponent],
  templateUrl: './pop-tray.component.html',
  styleUrls: ['./pop-tray.component.scss']
})
export class PopTrayComponent {
  @ViewChild('trayWrapper') trayWrapper!: ElementRef;

  @Input() header: string;
  @Input() description: string;
  @Input() showCloseButton: boolean = false;
  @Input() actions: {
    primaryButtons?: { text: string; function: () => void }[];
    secondaryButtons?: { text: string; function: () => void }[];
    closeFunction?: () => void;
  } = {};

  isInitialized: boolean = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isInitialized = true;
    }, 250);
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {
    if (
      this.actions?.closeFunction &&
      this.trayWrapper &&
      !this.trayWrapper.nativeElement.contains(event.target)
      && this.isInitialized === true
    ) {
      this.actions.closeFunction();
    }
  }

  onButtonClick(fn: () => void): void {
    if (typeof fn === 'function') {
      fn();
    }
  }

}
